import React, { useState } from "react";
import { useUpload } from "../context/UploadContext";
import {
  CheckCircle,
  Loader,
  ChevronDown,
  ChevronUp,
  SidebarCloseIcon,
  X
} from "lucide-react";

const UploadStatusBox = () => {
  const { uploads ,clearUploads} = useUpload();
  const [expanded, setExpanded] = useState(false);

  if (uploads.length === 0) return null;

  // Calculate total average progress
  const totalProgress = uploads.length
    ? Math.round(
        (uploads.filter((f) => f.status === "done").length / uploads.length) *
          100
      )
    : 0;

  const toggleExpand = () => setExpanded(!expanded);


  return (
    <div className="fixed bottom-4 right-4 w-80 bg-white shadow-lg border rounded-xl z-50 transition-all duration-300">
      {/* Header */}
      <div
        className="flex justify-between items-center px-3 py-2 border-b cursor-pointer"
        onClick={toggleExpand}>
        <h2 className="text-sm font-semibold">
          {uploads.some((f) => f.status === "uploading")
            ? `Uploading... ${totalProgress}%`
            : "Uploads Complete"}
        </h2>
        <div className="flex items-center space-x-2">
          {expanded ? (
            <ChevronDown className="h-4 w-4 text-gray-600" />
          ) : (
            <ChevronUp className="h-4 w-4 text-gray-600" />
          )}
          {uploads.some((f) => f.status === "done") && (
            <X className="h-4 w-4 text-gray-600" onClick={clearUploads} />
          )}
        </div>
      </div>

      {/* Progress Bar */}
      <div className="px-3 pb-1">
        <div className="w-full bg-gray-200 h-2 rounded">
          <div
            className="bg-blue-600 h-2 rounded transition-all duration-300"
            style={{ width: `${totalProgress}%` }}></div>
        </div>
      </div>

      {/* File List */}
      <div
        className={`overflow-y-auto transition-all duration-300 ${
          expanded ? "max-h-[384px]" : "max-h-14"
        }`}>
        <ul className="divide-y">
          {uploads.map((file, idx) => (
            <li
              key={idx}
              className="flex items-center justify-between px-3 py-1 text-sm">
              <span className="truncate max-w-[200px]">{file.name}</span>
              {file.status === "uploading" ? (
                <Loader className="animate-spin h-4 w-4 text-blue-500" />
              ) : (
                <CheckCircle className="h-4 w-4 text-green-600" />
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default UploadStatusBox;
